import React, { Component } from "react";
import FilterableVideoList from "../../components/FilterableVideoList/FilterableVideoList";
import { withFirebase } from "../../components/Firebase/Firebase";
import { withPrismic } from "../../components/Prismic/Prismic";
import RichText from "../../components/RichText/RichText";

class CompetitionStageClosed extends Component {

	render() {
		
		if(!this.props.terms && !this.props.terms.data) return null;

		const { videos, url } = this.props.competitions[this.props.competitionId];
		return (
			<div>
			<RichText content={this.props.terms.state_closed} />
			{this.props.terms.display_shortlist === "Visible" && <div>
				<FilterableVideoList title="Previous Videos" videos={videos} competitionSlug={url} />
			</div>}
			</div>
		);
	}
}

export default withPrismic(withFirebase(CompetitionStageClosed));



// WEBPACK FOOTER //
// ./src/pages/Competition/CompetitionStageClosed.js